import Vue from 'vue';

import reportingName from './ReportingName';
import reportingActions from './ReportingActions';
import client from './ReportingClient';
import { simplyfyFilterDataForBackend } from './simplifyFilterDataForBackend';

export default {
    headings: {
        cls_column: '',
        name: Vue.prototype.trans('reporting.label.user'),
        client_prefixed_name: Vue.prototype.trans('reporting.label.client'),
        course: Vue.prototype.trans('reporting.label.course'),
        status: Vue.prototype.trans('reporting.label.status'),
        actions: Vue.prototype.trans('vuetables.label.actions'),
    },

    texts: {
        count: Vue.prototype.trans('vuetables.label.countText'),
        filter: Vue.prototype.trans('vuetables.label.filter'),
        noResults: Vue.prototype.trans('vuetables.label.noResults'),
        loading: Vue.prototype.trans('vuetables.label.loading'),
        filterPlaceholder: Vue.prototype.trans('vuetables.label.search'),
    },

    sortable: ['name', 'client_prefixed_name'],

    templates: {
        name: reportingName,
        client_prefixed_name: client,
        actions: reportingActions,
    },

    requestFunction(data) {
        const simpleFilterData = simplyfyFilterDataForBackend(
            this.$parent.$parent.filter
        );
        const newData = Object.assign(data, simpleFilterData);

        return axios.get(this.url, {
            params: newData,
        });
    },
};
